<p class="invoice-card-title">Invoice Items</p>
<br />

<!-- Table View (Desktop) -->
<p-table
    #dt
    [columns]=""
    [autoLayout]="true"
    [value]="_reportService.selectedInvoiceDetails.invoiceItems"
    responsiveLayout="scroll"
    showLoader="true"
    rowHover="true"
    [customSort]="true"
    [style]="{ 'min-width': '100%' }"
    styleClass="invoice-items-table"
    *ngIf="viewMode === 'table'"
>
    <ng-template pTemplate="header">
        <tr>
            <th></th>
            <th>Item</th>
            <th>Transaction Type</th>
            <th>Price ({{ '' | currencySymbol }})</th>
            <th>Qty</th>
            <th style="text-align: right">Discount ({{ '' | currencySymbol }})</th>
            <th style="text-align: right">Total ({{ '' | currencySymbol }})</th>
            
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
            <td>
                <div class="conn-flex-image">
                    <img
                        src="{{
                            item.image != '' && item.image != 'noproduct'
                                ? item.image
                                : '/assets/images/default_product.png'
                        }}"
                        alt=""
                        width="28px"
                        height="28px"
                        style="border-radius: 50px"
                    />
                </div>
            </td>
            <td>{{ getInvoiceItemTitle(item) }} <i class="pi pi-info-circle" *ngIf="item.reasonNote" [pTooltip]="'Reason for Refund: '+item.reasonNote"></i>
          
            </td>
            <td>{{ item.invoiceTypeString }}</td>
            <td>{{ item.price | currency | currencySpacing }}</td>
            <td>{{ item.qty | number }}</td>
            <td style="text-align: right">{{ item.discount | currency | currencySpacing }}</td>
            <td style="text-align: right">{{ item.linePrice | currency | currencySpacing }}</td>
            
        </tr>
    </ng-template>

    <ng-template pTemplate="footer">
        <tr>
            <td colspan="5" style="border: 0px"></td>
            <td style="text-align: left; ">
                Total Items
            </td>
            <td style="text-align: right; ">
                {{
                    _reportService.selectedInvoiceDetails?.invoiceItems?.length
                }}
            </td>
        </tr>

        <tr>
            <td colspan="5" style="border: 0px"></td>
            <td style="text-align: left; ">
                Subtotal Total
            </td>
            <td style="text-align: right; ">
                {{ _reportService.selectedInvoiceDetails?.subTotal | currency | currencySpacing }}
            </td>
        </tr>

        <!-- <tr>
            <td colspan="5" style="border: 0px"></td>
            <td style="text-align: left; ">CC fees</td>
            <td style="text-align: right; ">
                {{
                    _reportService.selectedInvoiceDetails?.otherChargesAmount
                        | currency | currencySpacing
                }}
            </td>
        </tr>  -->

        <tr>
            <td colspan="5" style="border: 0px"></td>
            <td style="text-align: left; ">Discount</td>
            <td style="text-align: right; ">
                {{ _reportService.selectedInvoiceDetails?.discount | currency | currencySpacing }}
            </td>
        </tr>

        <tr>
            <td colspan="5" style="border: 0px"></td>
            <td style="text-align: left; ">Sales Tax</td>
            <td style="text-align: right; ">
                {{ _reportService.selectedInvoiceDetails?.salesTax | currency | currencySpacing }}
            </td>
        </tr>
        <tr>
            <td colspan="5" style="border: 0px"></td>
            <td style="text-align: left; ">Cash Discount</td>
            <td style="text-align: right; ">
                {{ _reportService.selectedInvoiceDetails?.cashDiscount  | currency | currencySpacing }}
            </td>
        </tr>

        <tr>
            <td colspan="5" style="border: 0px"></td>
            <td style="text-align: left; ">
                Shipping Cost
            </td>
            <td style="text-align: right; ">
                {{
                    _reportService.selectedInvoiceDetails?.shippingCost
                        | currency | currencySpacing
                }}
            </td>
        </tr>

        <tr>
            <td colspan="5" style="border: 0px"></td>
            <td style="text-align: left; ">
                Shipping Tax
            </td>
            <td style="text-align: right; ">
                {{
                    _reportService.selectedInvoiceDetails?.shippingTax
                        | currency | currencySpacing
                }}
            </td>
        </tr>

        <tr style="font-weight: bolder; font-size: 17px">
            <td colspan="5" style="border: 0px"></td>
            <td style="text-align: left">Grand Total</td>
            <td style="text-align: right">
                {{
                    _reportService.selectedInvoiceDetails.grandTotal | currency | currencySpacing
                }}
            </td>
        </tr>
        <tr *ngIf="!_reportService.selectedInvoiceDetails?.isOnlineOrder">
            <td colspan="5" style="border: 0px"></td>
            <td style="text-align: left; ">
               Tip
            </td>
            <td style="text-align: right; ">
                {{
                    _reportService.selectedInvoiceDetails?.tipAmount
                        | currency | currencySpacing
                }}
            </td>
        </tr>
        <tr style="font-weight: bolder; font-size: 17px">
            <td colspan="5" style="border: 0px"></td>
            <td style="text-align: left">Tendered</td>
            <td style="text-align: right">
                {{
                   _reportService.selectedInvoiceDetails?.tenderedAmount | currency | currencySpacing
                }}
            </td>
        </tr>
    </ng-template>
</p-table>

<!-- Grid View (Mobile) -->
<div *ngIf="viewMode === 'grid'" class="items-grid">
    <div *ngFor="let item of _reportService.selectedInvoiceDetails.invoiceItems" class="item-card">
        <!-- Product Image and Name -->
        <div class="card-header flex align-items-center gap-2">
            <div class="item-image">
                <img
                    [src]="
                        item.image != '' && item.image != 'noproduct'
                            ? item.image
                            : '/assets/images/default_product.png'
                    "
                    alt="{{ getInvoiceItemTitle(item) }}"
                />
            </div>
            <div class="flex-grow-1">
                <div class="item-name">{{ getInvoiceItemTitle(item) }}</div>
                <div class="item-txn-type">{{ item.invoiceTypeString }}</div>
            </div>
        </div>

        <!-- Card Body - Details -->
        <div class="card-body">
            <div class="detail-row">
                <span class="detail-label">Price:</span>
                <span class="detail-value">{{ item.price | currency | currencySpacing }}</span>
            </div>
            <div class="detail-row">
                <span class="detail-label">Qty:</span>
                <span class="detail-value">{{ item.qty | number }}</span>
            </div>
            <div class="detail-row">
                <span class="detail-label">Discount:</span>
                <span class="detail-value">{{ item.discount | currency | currencySpacing }}</span>
            </div>
            <div class="detail-row total">
                <span class="detail-label">Total:</span>
                <span class="detail-value">{{ item.linePrice | currency | currencySpacing }}</span>
            </div>
            <div class="detail-row" *ngIf="item.reasonNote">
                <span class="detail-label">Reason:</span>
                <span class="detail-value">{{ item.reasonNote }}</span>
            </div>
        </div>
    </div>
</div>

<!-- Summary Section (Mobile Only) -->
<div class="summary-section" *ngIf="viewMode === 'grid'">
    <div class="summary-row">
        <span>Total Items</span>
        <span>{{ _reportService.selectedInvoiceDetails?.invoiceItems?.length }}</span>
    </div>
    <div class="summary-row">
        <span>Subtotal</span>
        <span>{{ _reportService.selectedInvoiceDetails?.subTotal | currency | currencySpacing }}</span>
    </div>
    <div class="summary-row">
        <span>Discount</span>
        <span>{{ _reportService.selectedInvoiceDetails?.discount | currency | currencySpacing }}</span>
    </div>
    <div class="summary-row">
        <span>Sales Tax</span>
        <span>{{ _reportService.selectedInvoiceDetails?.salesTax | currency | currencySpacing }}</span>
    </div>
    <div class="summary-row">
        <span>Cash Discount</span>
        <span>{{ _reportService.selectedInvoiceDetails?.cashDiscount | currency | currencySpacing }}</span>
    </div>
    <div class="summary-row">
        <span>Shipping Cost</span>
        <span>{{ _reportService.selectedInvoiceDetails?.shippingCost | currency | currencySpacing }}</span>
    </div>
    <div class="summary-row">
        <span>Shipping Tax</span>
        <span>{{ _reportService.selectedInvoiceDetails?.shippingTax | currency | currencySpacing }}</span>
    </div>
    <div class="summary-row grand-total">
        <span>Grand Total</span>
        <span>{{ _reportService.selectedInvoiceDetails?.grandTotal | currency | currencySpacing }}</span>
    </div>
    <div class="summary-row" *ngIf="!_reportService.selectedInvoiceDetails?.isOnlineOrder">
        <span>Tip</span>
        <span>{{ _reportService.selectedInvoiceDetails?.tipAmount | currency | currencySpacing }}</span>
    </div>
    <div class="summary-row tendered">
        <span>Tendered</span>
        <span>{{ _reportService.selectedInvoiceDetails?.tenderedAmount | currency | currencySpacing }}</span>
    </div>
